var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"facility-photo",style:(_vm.cardImageStyle)},[(_vm.googleAttribution)?_c('span',{staticClass:"facility-photo__attribution",domProps:{"innerHTML":_vm._s('Photo by ' + _vm.googleAttribution)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }